import { useState, useCallback } from "react";
import { collection, query, where, getDocs, orderBy, limit, Timestamp, collectionGroup } from "firebase/firestore";
import { db } from "../firebase";

export default function useAdminStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [recentActivity, setRecentActivity] = useState([]);

  const loadStats = useCallback(async () => {
    setLoading(true);
    try {
      const [patientsSnap, doctorsApproved, doctorsPending, auditRecent] = await Promise.all([
        getDocs(query(collection(db, "patients"), where("activo", "==", true))),
        getDocs(query(collection(db, "users"), where("role", "==", "doctor"), where("approved", "==", true))),
        getDocs(query(collection(db, "users"), where("role", "==", "doctor"), where("approved", "==", false))),
        getDocs(query(collection(db, "audit_log"), orderBy("timestamp", "desc"), limit(20))),
      ]);

      // Count clinical records and photos across all patients using collectionGroup
      let totalRecords = 0;
      let totalPhotos = 0;
      let totalConsents = 0;
      try {
        const recordsSnap = await getDocs(query(collectionGroup(db, "clinical_records")));
        totalRecords = recordsSnap.size;
      } catch { /* collectionGroup may need index */ }
      try {
        const photosSnap = await getDocs(query(collectionGroup(db, "photos")));
        totalPhotos = photosSnap.size;
      } catch { /* collectionGroup may need index */ }
      try {
        const consentsSnap = await getDocs(query(collectionGroup(db, "consent_records")));
        totalConsents = consentsSnap.size;
      } catch { /* collectionGroup may need index */ }

      // Activity last 7 days
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
      const recentLogs = auditRecent.docs.map(d => ({ id: d.id, ...d.data() }));
      const last7 = recentLogs.filter(l => {
        if (!l.timestamp?.toDate) return false;
        return l.timestamp.toDate() >= sevenDaysAgo;
      });

      setStats({
        totalPatients: patientsSnap.size,
        totalRecords,
        totalPhotos,
        totalConsents,
        doctorsApproved: doctorsApproved.size,
        doctorsPending: doctorsPending.size,
        activityLast7Days: last7.length,
      });
      setRecentActivity(recentLogs);
    } catch (err) {
      console.error("Error loading admin stats:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  return { stats, loading, recentActivity, loadStats };
}
